// WarrantyHistoryReportPage.jsx
import React from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import useClaimHistoryReportData from './hook/useClaimHistoryReportData';
import ClaimHistoryReportTable from './component/ClaimHistoryReportTable';
import { useLanguage } from '../../../contexts/LanguageContext';
import GenericFileExportButton from '../../../components/common/GenericFileExportButton';
import { useLazyExportClaimHistoryToExcelQuery } from '../../../api/endpoints/claimHistoryReport';

const ClaimHistoryReportPage = () => {
    const { th } = useLanguage();
    const { apiData, isLoading, lazyParams, sortField, sortOrder, activeFilters, onPage, onSort, handleFilterChange, initFilters, exportParams } = useClaimHistoryReportData();

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('claimHistoryReport.title')}</h1>{' '}
                <div className="flex gap-2">
                    {' '}
                    <Button icon="pi pi-filter-slash" className="p-button-outlined p-button-secondary" onClick={initFilters} tooltip={th('filter.reset')} tooltipOptions={{ position: 'left' }} />
                    <GenericFileExportButton
                        useExportQuery={useLazyExportClaimHistoryToExcelQuery}
                        exportParams={exportParams}
                        buttonLabel="Excel"
                        buttonClassName="p-button-success"
                        icon="pi pi-file-excel"
                        fileNameExtractor={(result) => result?.fileName || 'garanti_talep_gecmisi.xlsx'}
                        dataExtractor={(result) => result?.fileBase64}
                        contentTypeExtractor={(result) => result?.contentType}
                    />
                </div>
            </div>
            <ClaimHistoryReportTable
                items={apiData?.items ?? []}
                totalCount={apiData?.totalCount ?? 0}
                loading={isLoading}
                lazyParams={lazyParams}
                onPage={onPage}
                activeFilters={activeFilters}
                onFiltersChange={handleFilterChange}
                sortField={sortField}
                sortOrder={sortOrder}
                onSortChange={onSort}
            />
        </div>
    );
};

export default ClaimHistoryReportPage;
